(function() {
  var isLocal = window.location.port === '9292' || window.location.hostname === '127.0.0.1';
  var CARDVAULT_ORIGIN = isLocal ? 'http://cards.the-vault.mx:3000' : 'https://cards.the-vault.mx';
  var API_BASE = CARDVAULT_ORIGIN + '/api/wishlist';

  function getVaultUser() {
    var match = document.cookie.match(/(?:^|;\s*)vault_user=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function initWishlistButtons() {
    var user = getVaultUser();
    var buttons = document.querySelectorAll('.vault-wishlist-btn');
    if (!buttons.length) return;

    // If logged in, check which products are in wishlist
    if (user) {
      var productIds = [];
      buttons.forEach(function(btn) {
        var pid = btn.getAttribute('data-wishlist-product-id');
        if (pid && productIds.indexOf(pid) === -1) productIds.push(pid);
      });

      if (productIds.length) {
        fetch(API_BASE + '/check', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Vault-User': user },
          credentials: 'include',
          body: JSON.stringify({ shopify_product_ids: productIds })
        })
        .then(function(res) { return res.json(); })
        .then(function(map) {
          buttons.forEach(function(btn) {
            var pid = btn.getAttribute('data-wishlist-product-id');
            if (map[pid]) {
              btn.classList.add('is-active');
              btn.setAttribute('aria-label', 'Quitar de wishlist');
              btn.setAttribute('title', 'Quitar de wishlist');
            }
          });
        })
        .catch(function() {});
      }
    }

    // Attach click handlers
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleToggle(btn);
      });
    });
  }

  function handleToggle(btn) {
    var user = getVaultUser();
    if (!user) {
      window.location.href = CARDVAULT_ORIGIN + '/login';
      return;
    }

    if (btn.classList.contains('is-loading')) return;

    var wasActive = btn.classList.contains('is-active');
    btn.classList.add('is-loading');
    btn.classList.toggle('is-active');

    var label = wasActive ? 'Agregar a wishlist' : 'Quitar de wishlist';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);

    // Normalize Shopify image URL to the canonical Shopify CDN so it works regardless
    // of origin. In prod, image_url is protocol-relative (//{shop}.myshopify.com/cdn/shop/...).
    // In dev, the Shopify CLI proxy serves /cdn/shop/... on a local host/port that only
    // works inside the proxy — rewrite those to the permanent myshopify CDN host.
    var SHOPIFY_CDN_HOST = 'https://f34c9b-7b.myshopify.com';
    var imageUrl = btn.getAttribute('data-wishlist-image') || '';
    if (imageUrl) {
      if (imageUrl.indexOf('//') === 0) {
        imageUrl = 'https:' + imageUrl;
      } else {
        var cdnIdx = imageUrl.indexOf('/cdn/shop/');
        if (cdnIdx !== -1 && imageUrl.indexOf('myshopify.com') === -1 && imageUrl.indexOf('cdn.shopify.com') === -1) {
          imageUrl = SHOPIFY_CDN_HOST + imageUrl.slice(cdnIdx);
        }
      }
    }

    fetch(API_BASE + '/toggle', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Vault-User': user },
      credentials: 'include',
      body: JSON.stringify({
        card_name: btn.getAttribute('data-wishlist-card-name'),
        shopify_product_id: btn.getAttribute('data-wishlist-product-id'),
        game_type: btn.getAttribute('data-wishlist-game-type'),
        image_url: imageUrl || null,
        current_price: parseFloat(btn.getAttribute('data-wishlist-price')) || null,
        expansion_code: btn.getAttribute('data-wishlist-expansion') || null,
        card_number: btn.getAttribute('data-wishlist-card-number') || null
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('API error');
      return res.json();
    })
    .then(function() {
      btn.classList.remove('is-loading');
    })
    .catch(function() {
      // Revert on error
      btn.classList.remove('is-loading');
      if (wasActive) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Quitar de wishlist');
        btn.setAttribute('title', 'Quitar de wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Agregar a wishlist');
        btn.setAttribute('title', 'Agregar a wishlist');
      }
    });
  }

  // Init on DOM ready and after Shopify section renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistButtons);
  } else {
    initWishlistButtons();
  }

  // Re-init when Shopify re-renders sections (AJAX pagination, etc.)
  document.addEventListener('shopify:section:load', initWishlistButtons);
})();
